import { Box } from "@material-ui/core";
import React from "react";
import { MemberNotificationList } from "./MemberNotificationList";
import { SubscriptionNotificationList } from "./SubscriptionNotificationList";
import { ConsentNotificationList } from "./ConsentNotificationList";
import { useSelector } from "react-redux";
import {  MY_TEAM_KEY } from "header/team-selector/TeamSelector";

export const NotificationList:React.FC = () => {

     const currentTeam = useSelector((state: any) =>
            state?.teamManager?.teams?.currentTeam);
    return (
        <Box mt={2}>
            <MemberNotificationList/>
            <Box mt={3} />
            <SubscriptionNotificationList/>
            {(process.env.REACT_APP_COUNCIL_TEAM_ID === currentTeam?.id ||
                localStorage.getItem(MY_TEAM_KEY) === process.env.REACT_APP_COUNCIL_TEAM_ID) && (<ConsentNotificationList/>)}
        </Box>
    );
}